<!-- TODO: add class/id to outer div so that we can add flex to it -->
<div [formGroup]="parentForm" id="radio-control-container">
  <mm-control-label [controlName]="radioModel.controlName" [label]="radioModel.title" [hasError]="hasError"
    [hasGreyText]="radioModel.hasGreyText || false" [greyText]="radioModel.greyText"
    [displayInlineTooltip]="radioModel.displayInlineTooltip ? true : false"
    [displayIconTooltip]="radioModel.displayIconTooltip ? true : false" [tooltip]="radioModel.tooltip" [secondLineGreyText]="radioModel.secondLineGreyText"
    id="radio-control-label">
  </mm-control-label>

  <div *ngFor="let radio of radioModel.radios">
    <div [class.is-hidden]="radio.hide">
      <div class="radio-container">
        <input type="radio" formControlName="{{radioModel.controlName}}" [value]="radio.value"
          id="{{radioModel.controlName + '-' + radio.value}}"
          [attr.data-testid]="radioModel.controlName + '-' + radio.value" [attr.disabled]="radio.disabled || null">
        <label for="{{radioModel.controlName + '-' + radio.value}}">
          <div [ngClass]="radio.disabled? 'radio-label-disabled':'radio-label'"
            *ngFor="let line of radio.label; let i = index"
            [attr.data-testid]="radioModel.controlName + '-' + radio.value + '-option-' + i">
            {{line}}
          </div>
        </label>
        <span id="warning" *ngIf="radio.warning && !radio.warning.displayBelow" [ngClass]="{'warning-disabled': radio.disabled}" [attr.data-testid]="radioModel.controlName + '-' + radio.value + '-warning'">
          <sdps-icon id="warning-icon" color="warning" type="functional" name="warning" size="small"></sdps-icon>
          <span id="warning-text">{{radio.warning.text}}</span>
          <a *ngIf="radio.warning.link" id="warningTextLink" (click)="redirect(radio)">{{radio.warning.link.text}}</a>
        </span>
      </div>
      <span id="warning-bottom" *ngIf="radio.warning && radio.warning.displayBelow" [attr.data-testid]="radioModel.controlName + '-' + radio.value + '-warning'">
        <sdps-icon id="warning-icon-bottom" color="warning" type="functional" name="warning" size="medium"></sdps-icon>
        <span id="warning-text-bottom">{{radio.warning.text}}</span>
        <a *ngIf="radio.warning.link" id="warningTextLink" (click)="redirect(radio)">{{radio.warning.link.text}}</a>
      </span>
    </div>
  </div>

  <span *ngIf="hasError && radioModel.radios.length > 0" class="error-text">{{errorText}}</span>
</div>
